<template>
  <div class="comp-message-nav" v-show="isShowTopMessage">
    <img :src="icon_notice" width="14">
    <span class="m_title">{{message.title}}</span>
    <a href="javascript:void(0);" @click="handleShow">点击查看</a>
    <i class="el-icon-close" @click="handleClose"></i>
    <messageDialog ref="m_dialog" @close="handleCloseDialog"></messageDialog>
  </div>
</template>

<script>
  import icon_notice from '../../assets/images/icon-notice.png';
  import messageDialog from '../MessageDialog/MessageDialog.vue';

  export default {
    data () {
      return {
        icon_notice,
        isShowTopMessage: false,
        message: {},
        messageVisible: false
      };
    },
    components: {
      messageDialog
    },
    created () {
      let postData = {
        platform: this.$agency.isHQ ? 'HQ' : 'IRS',
        pushType: 1
      };
      this.$axios.post('/crm-api/ces-web/user/api/v3/message/notifyMessage', this.$qs.stringify(postData)).then((res) => {
        let response = res.data;
        if (response) {
          if (+localStorage.getItem('localReadId') !== response.id) {
            this.message = response;
            this.isShowTopMessage = true;
          }
        }
      });
    },
    methods: {
      handleShow () {
        this.$refs.m_dialog.show(this.message.id, 1, true);
      },
      handleClose () {
        this.isShowTopMessage = false;
      },
      handleCloseDialog () {
        this.isShowTopMessage = false;
        localStorage.setItem('localReadId', this.message.id);
      }
    }
  };
</script>

<style lang="less">
  .comp-message-nav {
    margin: 10px;
    background: #fffce0;
    border: 1px solid #e0dec8;
    color: #333;
    font-size: 12px;
    height: 38px;
    line-height: 38px;
    padding-left: 14px;
    position: relative;

    .m_title {
      margin-left: 10px;
    }

    a {
      text-decoration: none;
      color: #016cdf;
    }

    .el-icon-close {
      top: 14px;
      right: 15px;
      position: absolute;
      cursor: pointer;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// MessageNav.vue?77d26c66